"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.componentArgs = void 0;
exports.componentArgs = {
    className: {
        description: 'Class name appended to root element of component',
        table: {
            type: {
                summary: 'string',
            },
            defaultValue: { summary: 'ss__${component-name}' },
        },
        control: { type: 'text' },
    },
    disableStyles: {
        defaultValue: false,
        description: 'Disable all default styling',
        table: {
            type: {
                summary: 'boolean',
            },
            defaultValue: { summary: false },
        },
        control: { type: 'boolean' },
    },
    style: {
        description: 'Inline style',
        table: {
            type: {
                summary: 'string, object',
            },
        },
        control: { type: 'text' },
    },
    theme: {
        description: 'Specify specific sub component props',
        table: {
            type: {
                summary: 'object',
            },
        },
        control: { type: 'object' },
    },
};
